<template>
	<nk-page commercialAccess="System">
		<div class="change-log-details h-100 d-flex flex-column overflow-auto">
			<div class="pt-2 h-100">
				<ag-grid :options="tableOptions" :data="tableData" ref="table"></ag-grid>
			</div>
		</div>
	</nk-page>
</template>

<script>
	import jalaliMoment from 'jalali-moment'
	import emptyId from '~/statics/empty-id'
	import _ from 'lodash'

	const ISO_DATE_REGEX1 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
	const ISO_DATE_REGEX2 = /^\d{4}\/\d{1,2}\/\d{1,2} \d{2}:\d{2}:\d{2}$/

	export default {
		modal: {
			size: 'lg',
			stateUID: 'change-log-details'
		},
		props: {
			options: Object,
		},
		data() {
			return {
				show: false,
				tableData: [],
				tableOptions: {
					id: this.$options.name,
					masterDetail: true,
					isRowMaster: (dataItem) => {
						return dataItem.hasDetails
					},
					rowGroupPanelShow: 'onlyWhenGrouping',
					detailCellRendererParams: {
						getDetailRowData: (params) => {
							let values = []
							if (Array.isArray(params.data.OriginalValue) || Array.isArray(params.data.CurrentValue)) {
								values = params.data.CurrentValue.filter((item) => {
									return !this.isFieldEmpty(item.CurrentValue) || !this.isFieldEmpty(item.OriginalValue)
								})
							}
							else {
								const originalValuesArray = JSON.parse(params.data.OriginalValue)
								const currentValuesArray = JSON.parse(params.data.CurrentValue)

								const originalValuesMap = _.keyBy(originalValuesArray, 'Name')
								const currentValuesMap = _.keyBy(currentValuesArray, 'Name')

								const allNames = _.union(_.map(originalValuesMap, 'Name'), _.map(currentValuesMap, 'Name'))

								values = allNames.reduce((items, name) => {
									const item = {
										Name: name,
										CurrentValue: currentValuesMap[name] ? currentValuesMap[name].Value : null,
										OriginalValue: originalValuesMap[name] ? originalValuesMap[name].Value : null
									}
									if (!this.isFieldEmpty(item.CurrentValue) || !this.isFieldEmpty(item.OriginalValue)) {
										items.push(item)
									}

									return items
								}, [])
							}
							params.successCallback(values)
						},
						detailGridOptions: {
							columnDefs: [
								{
									field: 'Name',
									headerName: this.$t('change-log.table.name'),
									contentType: 'string',
								},
								{
									field: 'OriginalValue',
									headerName: this.$t('change-log.table.old-value'),
									contentType: 'enum',
									valueFormatter: (params) => {
										return this.getReadableValue(params.value, params.data)
									}
								},
								{
									field: 'CurrentValue',
									headerName: this.$t('change-log.table.new-value'),
									contentType: 'enum',
									valueFormatter: (params) => {
										return this.getReadableValue(params.value, params.data)
									}
								},
							],
							nestedFieldName: 'details',
							rowSelection: {
								mode: 'singleRow'
							},
						}
					},
					columnDefs: [
						{
							field: 'Name',
							headerName: this.$t('change-log.table.name'),
							contentType: 'string',
							cellRenderer: 'agGroupCellRenderer',
						},
						{
							field: 'OriginalValue',
							headerName: this.$t('change-log.table.old-value'),
							contentType: 'enum',
							valueFormatter: (params) => {
								return this.getReadableValue(params.value, params.data)
							}
						},
						{
							field: 'CurrentValue',
							headerName: this.$t('change-log.table.new-value'),
							contentType: 'enum',
							valueFormatter: (params) => {
								return this.getReadableValue(params.value, params.data)
							}
						},
					]
				}
			}
		},
		created() {
			const data = this.options.items.reduce((items, item) => {
				try {
					if (Array.isArray(item.CurrentValue) || Array.isArray(item.OriginalValue) || Array.isArray(JSON.parse(item.CurrentValue)) || Array.isArray(JSON.parse(item.OriginalValue)))
						item.hasDetails = true
				}
				catch { }
				finally {
					if (item.hasDetails || !this.isFieldEmpty(item.CurrentValue) || !this.isFieldEmpty(item.OriginalValue)) {
						items.push(item)
					}

					return items
				}
			}, [])

			this.tableData = data
		},
		mounted() {
			this.prepareWindow(this.$t('change-log.f.change-details'))
		},
		methods: {
			getReadableValue(val, row) {
				if (typeof val === 'string') {

					if (row.hasDetails) {
						return ''
					}

					if (Number(val))
						return this.monify(val)

					try {
						if (ISO_DATE_REGEX1.test(val))
							return jalaliMoment(val, 'YYYY-MM-DDTHH:mm:ss').locale('fa').format('HH:mm:ss jYYYY/jMM/jDD')

						if (ISO_DATE_REGEX2.test(val))
							return jalaliMoment(val, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY/jMM/jDD')
					}
					catch {
						return ''
					}
				}

				else if (typeof val === 'number') {
					return this.monify(val)
				}

				else if (typeof val === 'object')
					return ''

				else if (typeof val === 'boolean')
					return String(val)

				return val
			},
			isFieldEmpty(field) {
				return !field || field === emptyId || field === '0001-01-01T00:00:00'
			},
		}
	}
</script>

<style>
	.change-log-details .table th {
		border-color: #fff;
		background-color: #fff;
		color: #000;
	}

	.change-log-details .table thead tr th {
		text-align: center;
		border-bottom: 1px solid #ececec !important;
		width: 33%;
	}

	.change-log-details .table thead tr th:nth-child(even) {
		border-left: 1px solid #ececec;
		border-right: 1px solid #ececec;
	}

	.change-log-details .table tbody tr {
		background-color: #fff;
	}

	.change-log-details .table tbody tr td {
		text-align: center;
		border-bottom: 1px solid #ececec !important;
	}
</style>
